import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "search-banner w-full bg-[length:400%] sm:bg-[length:145%] xl:bg-[length:125%] 2xl:bg-[length:120%] 3xl:bg-[length:120%] 4xl:bg-[length:130%] bg-no-repeat min-h-[35vh] bg-[position:46%_45%] sm:bg-[position:50%_45%] 4xl:bg-[position:50%_50%] relative before:absolute before:top-0 before:left-0 before:w-full before:h-4 before:bg-gradient-to-b before:from-black before:to-transparent before:opacity-20 after:absolute after:bottom-0 after:left-0 after:w-full after:h-4 after:bg-gradient-to-t after:from-black after:to-transparent after:opacity-20" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "flex flex-col items-center" }
const _hoisted_4 = { class: "w-[90vw] sm:w-[75vw] 2xl:w-[67vw] pt-[3.7vh] mx-auto relative" }
const _hoisted_5 = { class: "relative flex items-center" }
const _hoisted_6 = { class: "h-[8vh] px-[1.5vh] relative flex w-full items-center bg-white bg-opacity-80 shadow-[0_0_10px_1px_rgba(0,0,0,0.3)] shadow-gray-300 border-gray-200 rounded-xl border-y border-l" }
const _hoisted_7 = { class: "relative flex w-full items-center shadow-[0_0_20px_1px_rgba(0,0,0,0.3)] shadow-gray-200 rounded-2xl" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "absolute w-full z-50 border-x-8 border-transparent" }
const _hoisted_12 = { class: "bg-tethys-blue1-light bg-opacity-70 border-b border-x border-gray-300 rounded-b-lg max-h-[198px] overflow-y-auto shadow-xl w-full" }
const _hoisted_13 = {
  key: 0,
  class: "p-2 text-gray-500"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-sm sm:text-xs lg:text-sm" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "relative w-11/12 sm:w-4/5 2xl:w-3/4 max-h-screen bg-white rounded-md shadow-xl overflow-y-auto" }
const _hoisted_18 = { class: "flex border-b border-gray-200" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "p-8 text-xs 2xl:text-sm text-gray-700 leading-relaxed"
}
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "mb-5" }
const _hoisted_23 = { class: "text-tethys-blue1-dark font-bold text-base 2xl:text-lg" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "text-tethys-blue1-dark font-bold text-sm 2xl:text-base" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "text-tethys-blue1-dark font-bold text-sm 2xl:text-base" }
const _hoisted_30 = { class: "my-2" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = { class: "text-tethys-blue1-dark font-bold text-sm 2xl:text-base" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "text-tethys-blue1-dark font-bold text-sm 2xl:text-base" }
const _hoisted_36 = { class: "mt-8 text-center" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 1,
  class: "p-8 text-center text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "absolute bottom-1.5 right-1.5 inline-block px-2 py-0 text-[10px] font-normal text-gray-400 bg-gray-100 rounded-xl shadow-sm",
      title: _ctx.$t('data_type')
    }, " © ESRI ", 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "h-[5vh] z-0 pl-5 pr-4 text-tethys-blue2-dark rounded-s-lg bg-white",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search())),
                title: _ctx.$t('search')
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "fas fa-search text-2xl" }, null, -1)
              ]), 8, _hoisted_8),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "flex items-center h-[5vh] bg-white" }, [
                _createElementVNode("span", { class: "h-3/4 border-r-2 border-gray-200" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "search_query",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.display) = $event)),
                class: "h-[5vh] w-full py-2.5 text-gray-700 placeholder-gray-400 text-sm sm:text-xs lg:text-sm xl:text-base border-none focus:ring-0 focus:outline-none rounded-e-xl",
                type: "text",
                name: "q",
                autocomplete: "off",
                placeholder: _ctx.placeholder,
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchChanged && _ctx.searchChanged(...args))),
                onKeydown: [
                  _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                  _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                  _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
                  _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["tab"]))
                ],
                onFocus: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args)))
              }, null, 40, _hoisted_9), [
                [_vModelText, _ctx.display]
              ]),
              (_ctx.display)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "absolute right-2 px-4 py-2 border-x-2 border-y-2 text-xs lg:text-sm xl:text-base border-gray-100 text-gray-400 hover:bg-gray-200",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearSearch())),
                    title: _ctx.$t('clean_search_bar')
                  }, _cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                  ]), 8, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("ul", _hoisted_12, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, "Loading results..."))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.suggestions, (result, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    ref_for: true,
                    ref: _ctx.setItemRef,
                    class: _normalizeClass(["py-0.5 lg:py-1 px-3 cursor-pointer hover:bg-tethys-blue1-dark hover:text-white", { 'bg-teal-200': _ctx.isSelected(i) }]),
                    onClick: _withModifiers(($event: any) => (_ctx.select(result)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", {
                        innerHTML: _ctx.formatSuggestion(result)
                      }, null, 8, _hoisted_16)
                    ])
                  ], 10, _hoisted_14))
                }), 128))
          ], 512), [
            [_vShow, _ctx.showResults]
          ])
        ])
      ])
    ]),
    (_ctx.isShowLoginModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeLoginModal && _ctx.closeLoginModal(...args)), ["self"])),
          class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4",
          "aria-hidden": "true"
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeLoginModal && _ctx.closeLoginModal(...args))),
                class: _normalizeClass(
                            'w-1/2 text-sm font-semibold py-2 text-center transition-colors bg-gray-50 text-gray-400'
                        ),
                href: _ctx.portal,
                target: "_blank"
              }, _toDisplayString(_ctx.$t("login")), 9, _hoisted_19),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeTab = 'submit')),
                class: _normalizeClass([
                        'w-1/2 text-sm font-semibold py-2 text-center transition-colors',
                        _ctx.activeTab === 'submit' ? 'border-b-2 border-tethys-blue1-dark text-tethys-blue1-dark bg-white' : 'bg-gray-50 text-gray-400'
                    ])
              }, _toDisplayString(_ctx.$t("submit")), 3)
            ]),
            (_ctx.activeTab === 'submit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('loginPage.submission.title')), 1),
                      _createElementVNode("p", {
                        class: "my-2",
                        innerHTML: _ctx.getSanitizedTextWithLinks('loginPage.submission.text')
                      }, null, 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('loginPage.beforePublishing.title')), 1),
                      _createElementVNode("p", {
                        class: "my-2",
                        innerHTML: _ctx.getSanitizedTextWithLinks('loginPage.beforePublishing.text')
                      }, null, 8, _hoisted_27),
                      _cache[17] || (_cache[17] = _createElementVNode("p", { class: "italic text-gray-400 text-xs" }, "[noch in Bearbeitung]", -1))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('loginPage.submitData.title')), 1),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('loginPage.submitData.text')), 1),
                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "italic text-gray-400 text-xs" }, "[noch in Bearbeitung]", -1))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('loginPage.workflow.title')), 1),
                      _createElementVNode("p", {
                        class: "my-2",
                        innerHTML: _ctx.getSanitizedTextWithLinks('loginPage.workflow.text')
                      }, null, 8, _hoisted_33),
                      _cache[19] || (_cache[19] = _createElementVNode("p", { class: "italic text-gray-400 text-xs" }, "[noch in Bearbeitung]", -1))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('loginPage.signup.title')), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("p", { class: "italic text-gray-400 text-xs my-1" }, "[noch in Bearbeitung]", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("a", {
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeLoginModal && _ctx.closeLoginModal(...args))),
                      href: _ctx.portal,
                      target: "_blank",
                      class: "flex w-full justify-center sm:w-auto px-6 py-2 text-sm font-semibold bg-tethys-blue1-dark text-white rounded-md shadow hover:bg-tethys-7 transition"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("login")), 1)
                    ], 8, _hoisted_37)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[21] || (_cache[21] = [
                  _createElementVNode("p", { class: "text-sm" }, "Login form goes here.", -1)
                ]))),
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeLoginModal && _ctx.closeLoginModal(...args))),
              class: "absolute top-2 right-3 text-gray-400 hover:text-gray-700 transition",
              "aria-label": "Close"
            }, _cache[22] || (_cache[22] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "currentColor",
                viewBox: "0 0 20 20"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}